<template>
  <transition name="fade">
    <div
      class="QuizModal"
      v-if="show"
    >
      <div>
        <img
          width="30"
          height="30"
          src="@/assets/emojis/confetti-ball.svg"
        />
        <div>
          <h6>{{ title }}</h6>
          <p>{{ title.startsWith("0 out") ? 'Nice try!' : 'Good job!' }} Don't forget to share your results with friends and family.</p>
        </div>
      </div>
      <div>
        <a
          target="_blank"
          rel="noreferrer, noopener"
          :href="tw"
          class="button button--white twitter"
        >
          <img
            width="24"
            height="24"
            src="@/assets/icons/twitter-share.svg"
          />
          <span>Twitter</span>
        </a>
        <a
          target="_blank"
          rel="noreferrer, noopener"
          :href="fb"
          class="button button--white facebook"
        >
          <img
            width="24"
            height="24"
            src="@/assets/icons/facebook-share.svg"
          />
          <span>Facebook</span>
        </a>
        <a
          target="_blank"
          rel="noreferrer, noopener"
          :href="wa"
          class="button button--white whatsapp"
        >
          <img
            width="24"
            height="24"
            src="@/assets/icons/whatsapp-share.svg"
          />
          <span>Whatsapp</span>
        </a>
      </div>
      <button @click="close">
        <img src="@/assets/icons/close-24px.svg" />
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["show", "title", "fb", "tw", "wa"],
  setup(props, { emit }) {
    function close() {
      emit("close");
    }
    return {
      close,
    };
  },
};
</script>

<style>
.QuizModal {
  position: absolute;
  background: white;
  bottom: 20px;
  left: 50%;
  max-width: 1100px;
  width: calc(100% - 40px) !important;
  color: black;
  display: flex;
  flex-flow: column;
  align-items: center;
  border-radius: 8px;
  padding: 20px;
  padding-bottom: 40px;
  text-align: left;
  margin: 0 !important;
  transform: translateX(-50%);
  box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.1);
}
.QuizModal > button {
  background-color: #edeeef;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.QuizModal > button > img {
  width: 18px;
  height: 18px;
}
.QuizModal > div {
  display: flex;
  align-items: center;
  width: 100%;
}
.QuizModal > div:first-child {
  margin-bottom: 24px;
}
.QuizModal > div > img {
  margin-right: 20px;
}
.QuizModal h6 {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.6px;
}
.QuizModal p {
  text-align: left;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.42px;
  max-width: 100% !important;
  margin-bottom: 0 !important;
}
.QuizModal .button {
  line-height: 52px;
  height: 52px;
  width: 52px;
  border-radius: 52px;
  min-width: auto;
  padding: 0;
  margin: 0 10px;

  position: relative;
}
.QuizModal .button span {
  position: absolute;
  bottom: -38px;
  font-size: 12px;
}
.QuizModal .button img {
  margin: 0;
}
.twitter {
  background-color: #e3f6ff !important;
  color: #0198dc !important;
}
.facebook {
  background-color: #e9f2ff !important;
  color: #365ba5 !important;
}
.whatsapp {
  background-color: #e7faeb !important;
  color: #3fbd57 !important;
}

@media screen and (min-width: 800px) {
  .QuizModal {
    flex-flow: row !important;
    border-radius: 200px;
    padding: 20px 40px;
    padding-bottom: 20px;
  }
  .QuizModal > button {
    position: relative;
    top: 0;
    left: 0;
    flex: none;
  }
  .QuizModal > div:first-child {
    margin-bottom: 0;
  }
  .QuizModal > div:last-child {
    justify-content: flex-end;
  }
  .QuizModal .button {
    width: auto;
    padding: 20px;
  }
  .QuizModal .button img {
    margin-right: 10px;
  }
  .QuizModal .button span {
    position: relative;
    bottom: 0;
  }
}
</style>